import { HttpService } from 'src/app/services/http-wrapper.service';
import { ErrorMessageComponent } from 'src/app/shared/error-message/error-message.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.css']
})
export class AssignmentComponent implements OnInit {

  @ViewChild(ErrorMessageComponent)

  public errorComponent!: ErrorMessageComponent;
  formName!:string;
  recurrenceDuration = '';
  facilityName!:string;
  daysOfWeek =["Sun","Mon","Tues","Wed","Thu","Fri","Sat"];
  daysOfMonth =["First","Second","Third","Fourth","Fifth","Sixth","Seventh","Eighth","Ninth","Tenth","Eleventh","Twelfth","Thirteenth",
                "Fourteenth","Fifteenth","Sixteenth","Seventeenth","Eighteenth","Nineteenth","Twentieth","Twenty-first","Twenty-second",
                "Twenty-third","Twenty-fourth","Twenty-fifth","Twenty-sixth","Twenty-seventh","Twenty-eighth","Twenty-ninth",
                "Thirtieth","Thirty-first"];
  selectedDay ="First";
  repeatNoofDays!:string;
  repeatNoofWeeks!:string;
  repeatNoOfMonths!:string;

  constructor(public httpService : HttpService, private router: Router) {
    let state = this.router.getCurrentNavigation()?.extras.state;
    if (!state) {
      state = JSON.parse(localStorage.getItem('urlState') || '{}');
    }
    if (state) {
      this.formName = state.form.title
      this.facilityName = state.form.facilityName
    }  
  }

  submissionsData:any;
  query!: string;
  
  ngOnInit(): void {
      this.loadConfiguration();
  }
  onValChange(value: any){
    this.recurrenceDuration = value
  }
  assign(){
    const recurring= {
      repeat: 'monthly',
      day: 3,
      interval: 1
  }
  }
  loadConfiguration() {
    this.httpService.get("assets/submissions.json", this.errorComponent)
      .subscribe((dummyData) => {
        this.submissionsData = dummyData;
      });
  }

}
